<!-- <header class="mg-stellar-header mat-header">
  <div class="mg-back-close-container start">
    <button mat-icon-button
            [disableRipple]="true"
            *ngIf="stepper && stepper.selectedIndex > 0 && showBackIcon"
            (click)="onBack()"
            aria-label="back"
            color="primary"
            class="mg-back-button">
    </button>
  </div>
  <img class="mg-logo" src="assets/images/mgo-logo-black.svg" alt="MoneyGram" />
  <div class="mg-back-close-container end">
    <app-language-selector *ngIf="stepper && stepper.selectedIndex === 0 && (isMobile$ | async) === false" [labels] = "(labels$ | async)?.labels" [languages]="languageList"></app-language-selector>
    <div *ngIf="isSdfCardFlow">
      <img id="image-button" (click)="openBottomSheet()" (menuOpened)="menuOpened()" (menuClosed)="menuClosed()" [matMenuTriggerFor]="!isMobile ? customerSupportMenu: null" /> 
    </div>
  </div>
</header> -->
<!-- <ng-container *ngIf="((hasError$ | async) || showFlashPage || (isServerDown$ | async)) else anchorUI">
  <app-service-unavailable [labels] = "(labels$ | async)?.labels"></app-service-unavailable>
</ng-container>
<ng-template #anchorUI>
  <div class="modal" [attr.class]="'stepper-container step-' + stepper.selectedIndex" *ngIf="(labels$ | async)?.labels?.stellar?.ok && (isStatesResolved$ | async)">
    <mat-stepper orientation="horizontal" #stepper [linear]="false" (selectionChange)="scrollToTopOnStepChange()">
      <mat-step>
        <ng-container>
          <ng-container *ngIf="operation && token else noToken">
              <app-estimate *ngIf="!isSdfCardFlow" [amount]="amount"
                            [google]="google"
                            [disableAmount]= "disableAmount"
                            [labels] = "(labels$ | async)?.labels"
                            [options]="options$ | async"
                            [flow]="operation"
                            [token]="token"
                            [locale]="locale"
                            [indicativeRateCountry]="indicativeRateCountry"
                            [countryDetails]="countryDetails"
                            [endpoint]="endpointVersion"
                            (submitted)="callEstimate($event)">
              </app-estimate>
              <app-card-estimate *ngIf="isSdfCardFlow" [amount]="amount"
                            [google]="google"
                            [disableAmount]= "disableAmount"
                            [labels] = "(labels$ | async)?.labels"
                            [options]="options$ | async"
                            [flow]="operation"
                            [token]="token"
                            [locale]="locale"
                            [indicativeRateCountry]="indicativeRateCountry"
                            [countryDetails]="countryDetails"
                            [totalAmountToPay]="totalAmountToPay"
                            [totalAmountCurrency]="payOutAtLocationCurrency"
                            [feesCurrencyCode]="feesCurrencyCode"
                            [taxesCurrencyCode]="taxesCurrencyCode"
                            [selectedLocation]="selectedLocation"
                            [fees]="fees"
                            [taxes]="taxes"
                            (formValueChanges)="callEstimate($event)"
                            (next)="onNext(2)">
              </app-card-estimate>
          </ng-container>
        </ng-container> 
        <ng-template #noToken>
          <p *ngIf="(labels$ | async)?.labels as labels">{{labels.stellar.noToken}}</p>
        </ng-template>
      </mat-step>
      <mat-step>
        <div *ngIf="operation === 'deposit'">
            <app-locator-main [google]="google" [flow]="operation" [labels] = "(labels$ | async)?.labels" (locationSelected)=onLocationSelected($event)></app-locator-main>
        </div>
      </mat-step>
      <mat-step>
        <app-estimate-confirmation *ngIf="totalPayoutAmount"
                                   [labels] = "(labels$ | async)?.labels"
                                   [flow]="operation"
                                   [amount]="totalPayoutAmount"
                                   [totalAmountToPay]="totalAmountToPay"
                                   [totalUSDCAmount]="totalUSDCAmount"
                                   [exchangeAmount]="exchangeAmount"
                                   [feesCurrencyCode]="feesCurrencyCode"
                                   [partnerFeesCurrencyCode]="partnerFeesCurrencyCode"
                                   [taxesCurrencyCode]="taxesCurrencyCode"
                                   [partnerTaxesCurrencyCode]="partnerTaxesCurrencyCode"
                                   [exchangeRate]="exchangeRate"
                                   [fees]="fees"
                                   [partnerFees]="partnerFees"
                                   [taxes]="taxes"
                                   [partnerTaxes]="partnerTaxes"
                                   [discounts]="discounts"
                                   [locale]="locale"
                                   [payOutAtLocation]="payOutAtLocation"
                                   [payOutAtLocationCurrency]="payOutAtLocationCurrency"
                                   [currency]="payOutCurrency"
                                   [sendCurrency]="sendCurrency"
                                   [google]="google"
                                   (back)="onBack()"
                                   (next)="onNext()">
        </app-estimate-confirmation>
      </mat-step>
      <mat-step>
        <app-registration [transactionCountryCode]="country"
                          [senderData]="senderInfo"
                          [countries]="(countries$ | async)"
                          [labels]="(labels$ | async)?.labels"
                          (submitted)="onRegSubmit($event)"
                          [google]="google"
                          [locale]="locale"
                          [isStateFieldError]="(isAddrStateFieldError$ | async)"
                          [isCountryFieldError]="(isAddrCountryFieldError$ | async)"
                          [endpoint]="endpointVersion">
        </app-registration>
      </mat-step>
      <mat-step>
        <app-gffp #gffpComp
                  [enumerations]="(enumerationsResponse$ | async)"
                  [countries]="(countries$ | async)"
                  [labels] = "(labels$ | async)?.labels || {}"
                  [locale] = "locale"
                  [fieldNames]="(gffpFieldNames$ | async) || []"
                  [sendValResponseError]="sendValResponseError$ | async"
                  (submitted)="onGffpSubmit($event)">
        </app-gffp>
      </mat-step>
      <mat-step>
        <app-summary *ngIf="(summaryData$ | async) as summaryData"
                     [flow]="operation"
                     [labels] = "(labels$ | async)?.labels"
                     [wallet]="walletProvider"
                     [locale]="locale"
                     [exchangeRate]="exchangeRate"
                     [summaryData]="summaryData"
                     (next)="onCommit()">
        </app-summary>
      </mat-step>
      <mat-step>
        <app-confirmation *ngIf="commitResponse.sep24TransactionResponse" 
                      [commitResponse]="commitResponse"
                      [isExistingUser]="isExistingUser"
                      [labels] = "(labels$ | async)?.labels || {}"
                      [walletProvider]="walletProvider"
                      [isformFreeLocation]="isformFreeLocation"
                      [flow]="operation"
                      [google]="google"
                      [locale]="locale">
        </app-confirmation>
      </mat-step>
    </mat-stepper>
    <app-language-selector *ngIf="stepper && stepper.selectedIndex === 0 && (isMobile$ | async)" [labels] = "(labels$ | async)?.labels" [languages]="languageList"></app-language-selector>
    <div class="home-customer-support">
      <app-customer-support *ngIf="!isSdfCardFlow" [labels] = "(labels$ | async)?.labels"></app-customer-support>
    </div>
  </div>
</ng-template> -->

<!-- <mat-menu  #customerSupportMenu="matMenu" class="customize" yPosition="below" xPosition="before">
  <div *ngIf="(labels$ | async)?.labels?.stellar?.ok" class="customer-support-container">
    <div class="customer-support-item">
      <img class="customer-support-icon" src="assets\images\card-support-phone-icon.svg" alt="Customer Support Phone Icon" />
      <span class="customer-support-content">
        <p class="customer-support-label">{{ labels?.stellar?.customerSupport?.phoneLabel }}</p>
        <a  [href]="labels.stellar.customerSupport.supportPhoneNumberHref || 'tel:800-513-5175'" class="customer-support-info">{{ labels?.stellar?.customerSupport?.supportPhoneNumber }}</a>
      </span>
    </div>
    <div class="customer-support-item">
      <img class="customer-support-icon" src="assets\images\card-help-support-icon.svg" alt="Customer Support Phone Icon" />
      <div class="customer-support-content">
        <p class="customer-support-label">{{ labels?.stellar?.customerSupport?.submitHelpRequest }}​</p>
        <p class="customer-support-info"><a href="{{ labels?.stellar?.customerSupport?.supportUrl }}" target="_blank">{{ labels?.stellar?.customerSupport?.onlineHelpForm }}</a></p>
      </div>
    </div>
    <div class="customer-support-item">
      <img class="customer-support-icon" src="assets\images\card-support-email-icon.svg" alt="Customer Support Phone Icon" />
      <div class="customer-support-content">
        <p class="customer-support-label">{{ labels?.stellar?.customerSupport?.emailLabel }}</p>
          <p class="customer-support-info"><a href="mailto:{{labels.stellar.customerSupport.emailAddress}}">{{ labels.stellar.customerSupport.emailAddress }}</a></p>
      </div>
    </div>
  </div>
</mat-menu>  -->

<div class="mg-access-estimator">
  <div
    class="partner-wallet-banner"
    *ngIf="(isStatesResolved$ | async) && (isMobile$ | async) === false"
  >
    <app-partner-wallet-banner
      [walletProvider]="walletProvider"
      [stepper]="stepper"
      [showBackIcon]="showBackIcon"
      (back)="onBack()"
    >
    </app-partner-wallet-banner>
  </div>
  <section class="moneygram-top-nav">
    <div class="nav-content">
      <div
        class="return-icon"
        (click)="onBack()"
        *ngIf="
          stepper &&
          stepper.selectedIndex > 0 &&
          showBackIcon &&
          (isMobile$ | async)
        "
      >
        <img src="assets\images\arr-arrow-left-icon.svg" alt="" />
      </div>
      <div class="mg-logo-container">
        <img
          class="mg-logo"
          src="assets/images/mgo-logo-black.svg"
          alt="MoneyGram"
        />
      </div>
      <div class="empty"></div>
      <div class="language-and-support-container align-end">
        <app-language-selector
          *ngIf="stepper"
          [labels]="(labels$ | async)?.labels"
          [languages]="languageList"
        ></app-language-selector>
        <div *ngIf="isSdfCardFlow" class="img-container">
          <ng-container *ngIf="isSdfCardFlow">
            <app-card-customer-support
              [labels]="labels"
            ></app-card-customer-support>
          </ng-container>
        </div>
      </div>
    </div>
  </section>
  <ng-container
    *ngIf="
      (hasError$ | async) || showFlashPage || (isServerDown$ | async);
      else anchorUI
    "
  >
    <app-service-unavailable
      [labels]="(labels$ | async)?.labels"
    ></app-service-unavailable>
  </ng-container>
  <ng-template #anchorUI>
    <div
      class="modal"
      [attr.class]="'stepper-container step-' + stepper.selectedIndex"
      *ngIf="
        (labels$ | async)?.labels?.stellar?.ok && (isStatesResolved$ | async)
      "
    >
      <mat-stepper
        orientation="horizontal"
        #stepper
        [linear]="false"
        (selectionChange)="scrollToTopOnStepChange()"
      >
        <mat-step>
          <ng-container>
            <ng-container *ngIf="operation && token; else noToken">
              <app-estimate
                *ngIf="!isSdfCardFlow"
                [amount]="amount"
                [google]="google"
                [disableAmount]="disableAmount"
                [labels]="(labels$ | async)?.labels"
                [options]="options$ | async"
                [flow]="operation"
                [token]="token"
                [locale]="locale"
                [indicativeRateCountry]="indicativeRateCountry"
                [countryDetails]="countryDetails"
                (submitted)="callEstimate($event)"
              >
              </app-estimate>
              <app-card-estimate
                *ngIf="isSdfCardFlow"
                [amount]="amount"
                [google]="google"
                [disableAmount]="disableAmount"
                [labels]="(labels$ | async)?.labels"
                [serviceOptions]="options$ | async"
                [flow]="operation"
                [token]="token"
                [locale]="locale"
                [isWalletFeeEnabled]="(isWalletFeeEnabled$ | async)"
                [indicativeRateCountry]="indicativeRateCountry"
                [countryDetails]="countryDetails"
                [cmsMappingCountries]="serviceOptionsCmsMappingCountries"
                [selectedLocation]="selectedLocation"
                (formValueChanges)="callEstimate($event)"
                (next)="onNext(1)"
                [endpoint]="endpointVersion"
              >
              </app-card-estimate>
            </ng-container>
          </ng-container>
          <ng-template #noToken>
            <p *ngIf="(labels$ | async)?.labels as labels">
              {{ labels.stellar.noToken }}
            </p>
          </ng-template>
        </mat-step>
        <mat-step>
          <div *ngIf="operation === 'deposit'">
            <app-locator-main
              [google]="google"
              [flow]="operation"
              [labels]="(labels$ | async)?.labels"
              (locationSelected)="onLocationSelected($event)"
            ></app-locator-main>
          </div>
        </mat-step>
        <mat-step>
          <app-estimate-confirmation
            *ngIf="totalPayoutAmount"
            [labels]="(labels$ | async)?.labels"
            [flow]="operation"
            [amount]="totalPayoutAmount"
            [totalAmountToPay]="totalAmountToPay"
            [totalUSDCAmount]="totalUSDCAmount"
            [exchangeAmount]="exchangeAmount"
            [feesCurrencyCode]="feesCurrencyCode"
            [taxesCurrencyCode]="taxesCurrencyCode"
            [exchangeRate]="exchangeRate"
            [fees]="fees"
            [taxes]="taxes"
            [discounts]="discounts"
            [locale]="locale"
            [payOutAtLocation]="payOutAtLocation"
            [payOutAtLocationCurrency]="payOutAtLocationCurrency"
            [currency]="payOutCurrency"
            [sendCurrency]="sendCurrency"
            [google]="google"
            (back)="onBack()"
            (next)="onNext()"
          >
          </app-estimate-confirmation>
        </mat-step>
        <mat-step>
          <app-more-info
            (back)="onBack()"
            [labels]="(labels$ | async)?.labels"
            (next)="onNext()"
          >
          </app-more-info>
        </mat-step>
        <mat-step>
          <app-basic-info
            *ngIf="isSdfCardFlow"
            [transactionCountryCode]="country"
            [senderData]="senderInfo"
            [countries]="countries$ | async"
            [labels]="(labels$ | async)?.labels"
            (submitted)="onBasicSubmitInfo($event)"
            [locale]="locale"
          >
          </app-basic-info>
          <app-registration
            *ngIf="!isSdfCardFlow"
            [transactionCountryCode]="country"
            [senderData]="senderInfo"
            [countries]="countries$ | async"
            [labels]="(labels$ | async)?.labels"
            (submitted)="onRegSubmit($event)"
            [google]="google"
            [locale]="locale"
            [isStateFieldError]="isAddrStateFieldError$ | async"
            [isCountryFieldError]="isAddrCountryFieldError$ | async"
          >
          </app-registration>
        </mat-step>
        <mat-step>
          <app-address
            *ngIf="isSdfCardFlow"
            [transactionCountryCode]="country"
            [senderData]="senderInfo"
            [countries]="countries$ | async"
            [labels]="(labels$ | async)?.labels"
            (submitted)="onRegSubmit($event)"
            [locale]="locale"
            [isStateFieldError]="isAddrStateFieldError$ | async"
            [isCountryFieldError]="isAddrCountryFieldError$ | async"
            [endpoint]="endpointVersion"
          >
          </app-address>
        </mat-step>
        <mat-step>
          <app-gffp
            #gffpComp
            [enumerations]="enumerationsResponse$ | async"
            [countries]="countries$ | async"
            [labels]="(labels$ | async)?.labels || {}"
            [locale]="locale"
            [fieldNames]="(gffpFieldNames$ | async) || []"
            [sendValResponseError]="sendValResponseError$ | async"
            (submitted)="onGffpSubmit($event)"
          >
          </app-gffp>
        </mat-step>
        <mat-step>
          <div *ngIf="operation === 'deposit'">
            <app-fraud-warning
              [labels]="(labels$ | async)?.labels"
              (next)="onNext()"
            ></app-fraud-warning>
          </div>
        </mat-step>
        <mat-step>
          <app-summary
            *ngIf="summaryData$ | async as summaryData"
            [flow]="operation"
            [labels]="(labels$ | async)?.labels"
            [wallet]="walletProvider"
            [locale]="locale"
            [isWalletFeeEnabled]="(isWalletFeeEnabled$ | async)"
            [exchangeRate]="exchangeRate"
            [summaryData]="summaryData"
            [stateOptions]="stateOptions"
            [selectedLocation]="selectedLocation"
            (next)="onCommit()"
          >
          </app-summary>
        </mat-step>
        <mat-step>
          <app-confirmation
            *ngIf="
              commitResponse.sep24TransactionResponse &&
              (summaryData$ | async) as summaryData
            "
            [commitResponse]="commitResponse"
            [labels]="(labels$ | async)?.labels || {}"
            [walletProvider]="walletProvider"
            [isformFreeLocation]="isformFreeLocation"
            [isExistingUser]="isExistingProfile"
            [isWalletFeeEnabled]="(isWalletFeeEnabled$ | async)"
            [flow]="operation"
            [google]="google"
            [exchangeRate]="exchangeRate"
            [summaryData]="summaryData"
            [stateOptions]="stateOptions"
            [selectedLocation]="selectedLocation"
            [locale]="locale"
          >
          </app-confirmation>
        </mat-step>
      </mat-stepper>
      <!-- <app-language-selector *ngIf="stepper && stepper.selectedIndex === 0 && (isMobile$ | async)" [labels] = "(labels$ | async)?.labels" [languages]="languageList"></app-language-selector> -->
      <div class="home-customer-support">
        <app-customer-support
          *ngIf="!isSdfCardFlow"
          [labels]="(labels$ | async)?.labels"
        ></app-customer-support>
      </div>
    </div>
  </ng-template>
  <!-- <mat-menu  #customerSupportMenu="matMenu" class="customize" yPosition="below" xPosition="before">
    <div *ngIf="(labels$ | async)?.labels?.stellar?.ok" class="customer-support-container">
      <div class="customer-support-item">
        <img class="customer-support-icon" src="assets\images\card-support-phone-icon.svg" alt="Customer Support Phone Icon" />
        <span class="customer-support-content">
          <p class="customer-support-label">{{ labels?.stellar?.customerSupport?.phoneLabel }}</p>
          <a  [href]="labels.stellar.customerSupport.supportPhoneNumberHref || 'tel:800-513-5175'" class="customer-support-info">{{ labels?.stellar?.customerSupport?.supportPhoneNumber }}</a>
        </span>
      </div>
      <div class="customer-support-item">
        <img class="customer-support-icon" src="assets\images\card-help-support-icon.svg" alt="Customer Support Phone Icon" />
        <div class="customer-support-content">
          <p class="customer-support-label">{{ labels?.stellar?.customerSupport?.submitHelpRequest }}​</p>
          <p class="customer-support-info"><a href="{{ labels?.stellar?.customerSupport?.supportUrl }}" target="_blank">{{ labels?.stellar?.customerSupport?.onlineHelpForm }}</a></p>
        </div>
      </div>
      <div class="customer-support-item">
        <img class="customer-support-icon" src="assets\images\card-support-email-icon.svg" alt="Customer Support Phone Icon" />
        <div class="customer-support-content">
          <p class="customer-support-label">{{ labels?.stellar?.customerSupport?.emailLabel }}</p>
            <p class="customer-support-info"><a href="mailto:{{labels.stellar.customerSupport.emailAddress}}">{{ labels.stellar.customerSupport.emailAddress }}</a></p>
        </div>
      </div>
    </div>
  </mat-menu>  -->
</div>
